import styles from "../styles/Contact.module.scss";

function Contact() {
  return (
    <div className={styles.maincontainer}>
      <TitleSubtitle />
      <ContactButtons />
      <Separator />
      <Inputs />
      <SendButton />
    </div>
  );
}

var Separator = () => <div className={styles.separator}></div>;

function TitleSubtitle() {
  return (
    <div className={styles.titlesectiontitlecontainer}>
      <div className={styles.subtitle}>For project inquiry and information</div>
      <div className={styles.sectiontitle}>Contact me</div>
    </div>
  );
}
function ContactButtons() {
  return (
    <div className={styles.contactbuttonscontainer}>
      <ContactButton />
      <ContactButton />
      <ContactButton />
      <ContactButton />
      <ContactButton />
      <ContactButton />
    </div>
  );
}

function ContactButton() {
  return (
    <div className={styles.buttoncontainer}>
      <img
        alt="socialimage"
        src="https://img.icons8.com/plasticine/344/whatsapp.png"
        className={styles.icon}
      />
      <div className={styles.titledescriptioncontainer}>
        <div className={styles.buttontitle}>Whatsapp</div>
        <div className={styles.buttondescription}>Abdulsamad5sam@gmail.com</div>
      </div>
    </div>
  );
}
function Inputs() {
  return (
    <div className={styles.formcontainer}>
      <input className={styles.formfield} placeholder={"Your name"} />
      <input className={styles.formfield} placeholder={"Your email"} />
      <input
        className={styles.formfield}
        placeholder={"Project type(optional)"}
      />
      <input className={styles.formfield} placeholder={"Project budget"} />
      <input className={styles.formfield} placeholder={"Description"} />
    </div>
  );
}

function SendButton() {
  return (
    <div className={styles.sendbuttoncontainer}>
      <div className={styles.sendbutton}>Send</div>
    </div>
  );
}

export default Contact;
// src="https://img.icons8.com/color/344/linkedin-circled--v1.png"
// src="https://img.icons8.com/color/344/facebook-new.png"
